// Tiny controller for the fullscreen #appLoader.
// `variant` selects the animation/colour: 'auth' | 'username' | 'game'.
function getLoader() {
    return document.getElementById('appLoader');
}

export function showAppLoader(label, variant) {
    const el = getLoader();
    if (!el) {
        console.warn('showAppLoader: #appLoader not found');
        return;
    }
    if (variant) el.setAttribute('data-variant', variant);
    if (label) {
        const labelEl = el.querySelector('.app-loader-label');
        if (labelEl) labelEl.textContent = label;
    }
    el.classList.remove('hidden');
    // Defensive: force visibility regardless of any inline residue from
    // a prior hideAppLoader or stylesheet load order issues.
    el.style.opacity = '1';
    el.style.visibility = 'visible';
    el.style.pointerEvents = 'auto';
    el.style.display = 'flex';
}

export function hideAppLoader() {
    const el = getLoader();
    if (!el) return;
    el.classList.add('hidden');
    // Clear inline overrides so the .hidden class can take effect.
    el.style.opacity = '';
    el.style.visibility = '';
    el.style.pointerEvents = '';
    el.style.display = '';
}
